<template>
    <template v-if="searchRest != ''">
    <h1 class="fs-20 paddingv20 paddingh10"><span v-text="'搜索'"></span></h1>
    <div class="iconList clearfix clearfix">
        <div class="icons float-left cursor" v-for="(index,item) in icondata | filterBy searchRest in 'properties.name'" :style="'width:'+(iconysize * 2 + 8)*4+'px;'">
            <div class="icon_h bg-white text-center float-left" :style="{width:iconwidth,height:iconwidth}" style="line-height:72px;">
                <svg width="32" viewBox = "0 0 32 32" :width="iconysize" height="100%"><g transform="scale(0.03125 0.03125)"><path :d="itemPath" v-for='itemPath in item.icon.paths'></path></g></svg>
            </div>
            <input v-show="iconysize > 30" :value="'icon-'+item.properties.name" class="iconInput float-left paddingh10" style="border:0;font-size:30px;" :style="'width:calc(100% - '+iconwidth+');border:0;font-size:30px;line-height:'+iconwidth+';font-size:'+this.iconysize+'px;'">
        </div>
        <div v-if="!filterIconData(icondata,searchRest).length">查无记录</div>
    </div>
    </template>
    <template v-else>
        <template v-if="selectDir.length > 0">
            <h1 class="fs-20 paddingv20 paddingh10" v-show="selectDir != 'other'"><span v-text="selectName"></span><span v-text="filterIconData(icondata,selectDir).length" class="marginl20 text-red"></span></h1>
            <div class="iconList clearfix clearfix">
                <div class="icons float-left cursor" v-for="item in filterIconData(icondata,selectDir)" :style="'width:'+(iconysize * 2 + 8)*4+'px;'">
                    <div class="icon_h bg-white text-center float-left" :style="{width:iconwidth,height:iconwidth}" style="line-height:72px;">
                        <svg width="32" viewBox = "0 0 32 32" :width="iconysize" height="100%"><g transform="scale(0.03125 0.03125)"><path :d="itemPath" v-for='itemPath in item.icon.paths'></path></g></svg>
                    </div>
                    <input v-show="iconysize > 30" :value="'icon-'+item.properties.name" class="iconInput float-left paddingh10" style="border:0;font-size:30px;" :style="'width:calc(100% - '+iconwidth+');border:0;font-size:30px;line-height:'+iconwidth+';font-size:'+this.iconysize+'px;'">
                </div>
            </div>
        </template>
        <template v-else>
            <template v-for="itemD in tgouDir">
            <h1 class="fs-20 paddingv20 paddingh10"><span v-text="itemD.name.replace('_','/')"></span><span v-text="filterIconData(icondata,itemD.dir).length" class="marginl20 text-red"></span></h1>
            <div class="iconList clearfix clearfix">
                <div class="icons float-left cursor flex-container vfull" v-for="item in filterIconData(icondata,itemD.dir)" :style="'width:'+(iconysize * 2 + 8)*4+'px;'" @click="svgShow(item.properties.name,item.icon.paths)">
                    <div class="icon_h bg-white text-center float-left" :style="{width:iconwidth,height:iconwidth}" style="line-height:72px;">
                        <svg width="32" viewBox = "0 0 32 32" :width="iconysize" height="100%"><g transform="scale(0.03125 0.03125)"><path :d="itemPath" v-for='itemPath in item.icon.paths'></path></g></svg>
                    </div>
                    <div class="float-left flex-container-col vfull">
                        <input v-show="iconysize > 30" :value="'icon-'+item.properties.name" class="iconInput paddingh10" style="border:0;font-size:30px;" :style="'width:calc(100% - '+iconwidth+');border:0;font-size:30px;font-size:'+this.iconysize/2+'px;'">
                        <div v-show="iconysize > 30" v-text="item.icon.tags[0]" class="iconInput paddingh10" style="border:0;font-size:30px;" :style="'width:calc(100% - '+iconwidth+');border:0;font-size:30px;line-height:2;font-size:'+this.iconysize/2+'px;'"></div>
                    </div>
                    
                </div>
            </div>
            </template>
            
        </template>
    </template>
    <template v-if="(selectDir == '' && searchRest == '') || otherShow == true">
        <div v-show="listData">
            <h1 class="fs-20 paddingv20 paddingh10"><span v-text="'其它'"></span><span v-text="noFilter.length" class="marginl20 text-red"></span></h1>
            <div class="iconList clearfix clearfix">
                <div class="icons float-left cursor" v-for="item in noFilter" :style="'width:'+(iconysize * 2 + 8)*4+'px;'">
                    <div class="icon_h bg-white text-center float-left" :style="{width:iconwidth,height:iconwidth}" style="line-height:72px;">
                        <svg width="32" viewBox = "0 0 32 32" :width="iconysize" height="100%"><g transform="scale(0.03125 0.03125)"><path :d="itemPath" v-for='itemPath in item.icon.paths'></path></g></svg>
                    </div>
                    <input v-show="iconysize > 30" :value="'icon-'+item.properties.name" class="iconInput float-left paddingh10" style="border:0;font-size:30px;" :style="'width:calc(100% - '+iconwidth+');border:0;font-size:30px;line-height:'+iconwidth+';font-size:'+this.iconysize+'px;'">
                </div>
            </div>
        </div>
    </template>
</template>
<script>
import $ from 'jquery';
export default {
    props:{
        icondata:{
            type:Array,
            default:""
        },
        iconysize:{
            type:Number,
            default:32
        },
        max:{
            type:Number,
            default:1024
        },
        searchRest:{
            type:String,
            default:''
        },
        selectDir:{
            type:String,
            default:''
        },
        selectName:{
            type:String,
            default:''
        },
        otherShow:{
            type:Boolean,
            default:true
        }
    },
    computed:{
        iconwidth:function(){
            return (this.iconysize * 2 + 8) + 'px'
        },
        fontSize:function(){
            return (this.iconysize / 3) + 'px'
        },
        noFilter:function(){
            for (var i=0; i<this.tgouDir.length;i++){
                if(this.listData){
                    this.listData = this.noFilterIconData(this.listData,this.tgouDir[i].dir)
                } else {
                    this.listData = this.noFilterIconData(this.icondata,this.tgouDir[i].dir)
                }
            }
            console.log(this.selectDir.dir)
            return this.listData
        }
    },
    ready:function(){
        $('svg').attr('viewBox','0 0 ' + this.iconysize + ' ' + this.iconysize);
        $('svg g').attr('transform','scale('+this.iconysize/this.max+' '+this.iconysize/this.max+')');
    },
    methods: {
        addstyle(e,active,tpl,cls,add,tplName,tplText) {
            if(add == 'doubleCircle'){
                $(e).siblings('.'+tpl).removeClass('active');
                if($(e).hasClass('active')){
                    $(e).removeClass('active');
                }else{
                    $(e).addClass('active');
                }
            } else {
                $(e).toggleClass('active');
            }
            this.$dispatch('resultClass',active,tpl,cls,tplName,tplText);
        }
    }
}
</script>
<style>
@import './style.css';
</style>
